<app-lms-modal-frame [title]="title || dlgData.title" [pageHeadWidth]="300">
  <div modal-body>
    <p class="fs-6 text-center" [innerHTML]="message || dlgData.message">
      <!-- <b>{{message || dlgData.message}}</b> -->
    </p>
  </div>

  <div modal-actions class="lms-action-bar">
    <button *ngIf="!showClose" class="btn btn-primary me-2" mdbRipple (click)="onDismiss()">Cancel</button>
    <button *ngIf="!showClose" class="btn btn-primary me-2" mdbRipple (click)="onConfirm()">Yes</button>
    <button *ngIf="showClose" class="btn btn-primary me-2" mdbRipple (click)="onConfirm()">Close</button>
  </div>
</app-lms-modal-frame>
